import {ISolicitacao} from "@models/solicitacoes/solicitacoes.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useEffect, useMemo, useState} from "react";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {UsuarioPesquisa} from "@components/usuario/UsuarioPesquisa.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {Button, ButtonGroup, Grid} from "@mui/material";
import {fullHeight} from "@models/helpers.ts";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";
import {IOperationResponse} from "@localization/siteMap/siteMapInterfaces.ts";

interface TransferirSolicitacaoComponentProps extends DefaultPageProps {
    solicitacao: number | ISolicitacao,
    onUpdate?: (v: IOperationResponse<ISolicitacao>) => void,
}

export function TransferirSolicitacaoComponent(props: TransferirSolicitacaoComponentProps) {
    const {transferirSolicitacao} = useSolicitacao()
    const [novoUser, setNovoUser] = useState<IUsuario | undefined>()
    const [value, setValue] = useState<ISolicitacao | undefined>()

    useEffect(() => {
        if (typeof props.solicitacao == 'object') {
            setValue(props.solicitacao);
        } else {
            // TODO: buscar solicitacao
            setValue(undefined);
        }

    }, [props.solicitacao]);

    const isTransferivel = useMemo(() => {
        return (value != null && novoUser != null && value.solicitanteId != novoUser.id)
    }, [value, novoUser]);

    return (<DefaultContainer hideHeader={props.hideHeader}
                              titulo={`Transferindo a solicitação ${value?.titulo}`}
                              permissaoNecessaria={['EditarSolicitacaoOutros']}>
        <Grid container size={12} component={ButtonGroup}>
            <Grid size={{xs: 12, md: 6}}>
                <UsuarioPesquisa display={{
                    label: 'Novo usuário',
                }} onItemSelected={setNovoUser}/>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Button disabled={!isTransferivel}
                        onClick={() => {
                            if (value != null && novoUser != null) {
                                transferirSolicitacao({
                                    idSolicitacao: value.id,
                                    idNovoSolicitante: novoUser.id
                                }).then(x => {
                                    if (x.status == 'Success') {
                                        if (props.onUpdate != null)
                                            props.onUpdate(x)
                                    }
                                })
                            }
                        }}
                        fullWidth
                        sx={{...fullHeight}}>Transferir</Button>
            </Grid>
        </Grid>
    </DefaultContainer>)
}